<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="data.Status==2 || !canWrite">新增</el-button>
      <el-button type="primary" @click.native="save" :disabled="(data.Status==2&&!is_orderUpdateStatus) || !canWrite">保存</el-button>
      <el-button type="primary" @click.native="orderUpdate" :disabled="data.Status != 2 || !canWrite">变更</el-button>
      <el-button type="primary" @click.native="orderDel" :disabled="!isSave || data.Status==2 || !canWrite">删除</el-button>
      <el-button type="primary" @click.native="orderReview" :disabled="!isSave || !canReview">{{ ReviewName }}</el-button>
      <el-dropdown>
        <el-button type="primary" :disabled="!isSave">
          联查<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px" @click.native="goJump">
          <el-dropdown-item class="dropdown-item">销售订单</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="openPrint" :disabled="!isSave">打印</el-button>
      <el-button type="primary" @click="openSetField">明细字段</el-button>
    </div>
    <el-form :inline="true" :model="data" :line-form="true" label-width="90px" ref="ruleForm" :rules="rules" status-icon>
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="DocDate">
          <span class="not-edit" v-if="ReviewStatus">{{ $commonJs.toDateString(data.DocDate) }}</span>
          <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" :clearable="false"
            @change="val=>previewNo(val)" />
        </el-form-item>
        <el-form-item label="单据编码:" prop="DocNo">
          <span v-if="Mode == 0 || ReviewStatus" class="not-edit" style="min-width: 180px">{{ data.DocNo }}</span>
          <el-input v-else v-model="data.DocNo" placeholder="请输入单据编码" />
        </el-form-item>
        <el-form-item label="客户:" prop="TradeUnitId">
          <span class="not-edit" v-if="ReviewStatus">{{ data.TradeUnitName }}</span>
          <!-- <select-input
            v-else
            placeholder="请选择客户"
            :label="data.TradeUnitName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
          /> -->
          <el-select v-else v-model="data.TradeUnitId" filterable style="width: 180px">
            <div style="max-height: 274px;overflow: scroll;margin-bottom: -17px;margin-right: -17px;">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName" @click.native="setTradeunit(item)"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式:" prop="TransportId">
          <span class="not-edit" v-if="ReviewStatus">{{ data.TransportName }}</span>
          <el-select v-else v-model="data.TransportId" style="width: 180px">
            <el-option v-for="item in transportList" :key="item.TransportId" :value="item.TransportId" :label="item.TransportName"></el-option>
          </el-select>
        </el-form-item>
        <!-- 经手人 -->
        <el-form-item label="经手人:" prop="EmpId">
          <span class="not-edit" v-if="ReviewStatus">{{ data.EmpName }}</span>
          <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:">
          {{ data.MakeEmpName }}
        </el-form-item>
        <el-form-item label="送货地址:">
          <span class="not-edit" v-if="ReviewStatus">{{ data.Address }}</span>
          <el-input v-else type="textarea" v-model="data.Address" maxlength="60" placeholder="请填写地址" :autosize="{ minRows: 1, maxRows: 2 }" style="width: 460px" />
        </el-form-item>
      </el-row>
      <!--  -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:">
            <span v-if="orderUpdateStatus">{{ data.Remark }}</span>
            <el-input v-else type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" style="width: 600px" />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row style="margin: 0px 0 20px">
        <el-table border :data="tableList" class="tableList" :row-class-name="tableRowClassName" @row-click="addColumn" v-keymove="addList">
          <insert-row @on-insert="onInsert" />
          <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.Remark }}</span>
              <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="条形码" min-width="140px">
            <template slot-scope="{ row }">
              <vue-barcode
                :value="row.ProductNo"
                width="1"
                height="20"
                fontSize="10"
              ></vue-barcode>
            </template>
          </el-table-column> -->
          <el-table-column align="left" label="存货名称" min-width="120px" v-if="showField('存货名称')">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.ProductName }}</span>
              <account-select v-else v-model="row.ProductName" :source="DAccount" @select="onSelect($event, row)" :pageSize="pageParams.pageSize" :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal" @inputText="inputText" @click.native="resetFun" @currentPage="currentPage" :pageType="true" />
            </template>
          </el-table-column>
          <el-table-column align="left" label="存货编码" min-width="140px" v-if="showField('存货编码')">
            <template slot-scope="{ row }">
              <span>{{ row.ProductNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="规格型号" v-if="showField('规格型号')">
            <template slot-scope="{ row }">
              <span>{{ row.ProductSpec }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="颜色" min-width="120px" v-if="showField('颜色')">
            <template slot-scope="{ row, $index }">
              <el-select v-if="row.UseColor && !ReviewStatus" v-model="row.ColorId" @change="changeColor(row, $index)">
                <el-option v-for="item in row.Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName" :disabled="item.Status==0" />
              </el-select>
              <span v-else>{{ row.ColorName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="销售单位" min-width="120px" v-if="showField('销售单位')">
            <template slot-scope="{ row,$index}">
              <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus" v-model="row.SaUnitId">
                <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
              </el-select>
              <span v-else>{{ row.SaUnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="数量" min-width="120px" v-if="showField('数量')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.SaQuantity) }}</span>
              <el-input v-else v-quantity:[option]="option" type="text" v-model="row.SaQuantity" @change="changeQuantity($event, row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="left" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
            <template slot-scope="{ row, $index }">
              <!-- <span>{{ row }}{{ $index }}</span> -->
              <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus" v-model="row.UnitId2">
                <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
              </el-select>
              <span v-else-if="row.UnitType==0"></span>
              <span v-else>{{ row.UnitName2 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="数量2" v-if="showField('数量2')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Quantity2) }}</span>
              <span v-else-if="row.UnitType==0"></span>
              <el-input v-else type="text" v-model.number="row.Quantity2" @change="changeQuantity2($event,row, $index)" @blur="getChangeQuantity($event,row, $index)" />
            </template>
          </el-table-column>
          <el-table-column align="right" label="换算率" v-if="showField('换算率')">
            <template slot-scope="{ row, $index }">
              <span v-if="(ReviewStatus || row.ChangeType==0) && row.UnitType==1">{{ row.Rate }}</span>
              <span v-else-if="row.UnitType==0"></span>
              <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="最新含税进价" min-width="120px" v-if="canPrice&&showField('最新含税进价')">
            <template slot-scope="{ row }">
              <span>{{ row.PurchasePrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="最新含税售价" min-width="120px" v-if="canPrice&&showField('最新含税售价')">
            <template slot-scope="{ row }">
              <span>{{ row.SalePrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="最低售价" v-if="canPrice&&showField('最低售价')">
            <template slot-scope="{ row }">
              <span>{{ row.RetailPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice&&showField('报价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.QuotedPrice }}</span>
              <el-input v-else v-price type="text" v-model="row.QuotedPrice" :disabled="row.Gift" @change="changeQuotedPrice(row, $index)">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice&&showField('折扣%')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Discount }}</span>
              <el-input v-else v-decimals type="text" v-model.number="row.Discount" :disabled="row.Gift" @input="changeDiscount(row, $index)" />
            </template>
          </el-table-column>
          <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice&&showField('税率%')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxRate }}</span>
              <el-input v-else v-decimals v-limit:value="{ max: 100, min: 0 }" type="text" v-model.number="row.TaxRate" :disabled="row.Gift"
                @input="changeTaxRate(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="单价" min-width="140px" v-if="canPrice&&showField('单价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input v-else v-price type="text" v-model="row.Price" :disabled="row.IsGift" @change="changePrice(row, $index)">
                <el-button v-if="row.ProductName" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button>
              </el-input>
            </template>
            <!-- <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input
                v-else
                v-price
                 type="text"
                v-model.number="row.Price"
                :disabled="row.Gift"
                @input="changePrice(row, $index)"
              ></el-input>
            </template> -->
          </el-table-column>
          <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice&&showField('含税单价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxPrice }}</span>
              <el-input v-else v-price type="text" v-model.number="row.TaxPrice" :disabled="row.Gift" @input="changeTaxPrice(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice&&showField('金额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Amount) }}</span>
              <el-input v-else v-decimals type="text" v-model.number="row.Amount" :disabled="row.Gift" @input="changeAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice&&showField('税额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxLimit) }}</span>
              <el-input v-else v-decimals type="text" v-model.number="row.TaxLimit" :disabled="row.Gift" @input="changeTaxLimit(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice&&showField('含税金额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxAmount) }}</span>
              <el-input v-else v-decimals type="text" v-model.number="row.TaxAmount" :disabled="row.Gift" @input="changeTaxAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice&&showField('折扣金额')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
              <el-input v-else v-decimals type="text" v-model.number="row.DiscountAmount" :disabled="row.Gift" @input="changeDiscountAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="行中止" v-if="showField('行中止')">
            <template slot-scope="{ row }">
              <el-checkbox v-model="row.LineAbort" @change="changeLineAbort($event, row)" :disabled="isLineAbort || orderUpdateStatus"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column align="left" label="中止人" v-if="showField('中止人')">
            <template slot-scope="{ row }">
              <span>{{ row.LineAbortEmpName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="中止时间" min-width="100px" v-if="showField('中止时间')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" v-if="!ReviewStatus">
            <template slot-scope="{ row, $index }">
              <el-button v-if="$permission.canWrite('/business/sales/quotation')" type="text" @click.stop="delTableList(row, $index)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 180px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 180px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 180px">
          {{ data.UpdateEmpName }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 180px">
          {{ $commonJs.toDateString(data.UpdateDate) }}
        </el-form-item>
      </el-row>
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <order-dialog ref="orderDialog" @save="initerPrice" in-dialog />
    <print-dialog ref="printDialog" :columns="columns" :data="columnData" :form-data="formData"></print-dialog>
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import curdMixins from "@/mixins/trend/curd";
import empDialog from "@/components/personnel/result/record/listDialog";
import orderDialog from "@/components/business/sales/sale/priceDialog";
import printDialog from "@/components/common/printDialog/printDialog";
import accountSelect from "@/components/business/sales/select";
// import list from "@/components/business/purchase/inquiry/list";
import quotationList from "@/data/business/sales/quotation/edit/list.json";
import optionMixins from "@/mixins/option";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import fieldDialog from "@/components/common/fieldDialog"
export default {
  name: "editQuotation",
  mixins: [curdMixins, optionMixins],
  components: {
    // list,
    empDialog,
    orderDialog,
    accountSelect,
    VueBarcode,
    printDialog,
    tradeunitDialog,
    fieldDialog,
  },
  data() {
    return {
      optionApi: require("@/api/sy/option").default,
      api: require("@/api/sa/quotation").default,
      adressApi: require("@/api/ba/tradeUnitContact").default,
      pdApi: require("@/api/ba/product").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      transportApi: require("@/api/ba/transport").default,
      code_api: require("@/api/sy/serialCode").default,
      docSetting_api: require('@/api/sy/docSetting').default,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      colorList: [],
      listTotal: 0,
      Status: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      data: {
        QuotationId: 0,
        DocDate: this.$commonJs.getToday(),
        DocNo: "",
        TradeUnitId: "",
        TransportId: null,
        Address: "",
        Remark: "",
        Status: 0,
        EmpId: 0,
        DpId: 0,
        MakeEmpId: 0,
        // MakeDate: "",
        ReviewEmpId: 0,
        ReviewDate: "",
        UpdateEmpId: 0,
        UpdateDate: "",
        // AddTime: "",
        TransportName: "",
        DpName: "",
        DpNo: "",
        EmpName: "",
        TradeUnitNo: "",
        ShortName: "",
        TradeUnitName: "",
        TradeUnitType: 0,
        MakeEmpName: "",
        ReviewEmpName: "",
        UpdateEmpName: "",
        ExecStatus: 0,
        DeliveryStatus: 0,
        TradeUnitClassName: "",
        Amount: 0,
        ProductModels: [],
      },
      isMainUnitId2: false,
      Mode: 0,
      isSave: false,
      tabPosition: "",
      reach: "联查",
      handledBy: "",
      preparedBy: "",
      Gift: false,
      service: null,
      is_orderUpdateStatus: false,
      productList: [],
      tradeUnitList: [],
      transportList: [],
      tableList: [],
      optionList: [],
      rules: {
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        DocNo: [{ required: true, message: "单据编码不能为空" }],
        TradeUnitId: [
          { required: true, message: "客户不能为空", trigger: "change" },
        ],
        Address: [{ required: true, message: "送货地址不能为空" }],
        // TransportId: [{ required: true, message: "运输方式不能为空" }],
        EmpId: [{ required: true, message: "经手人不能为空" }],
        Remark: [{ required: true, message: "备注不能为空" }],
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        Quantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true,
      },
      detailFields: [],
      showDetail: false
    };
  },
  computed: {
    orderUpdateStatus() {
      return this.data.Status == 2 && !this.is_orderUpdateStatus ? true : false;
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    isLineAbort() {
      return this.data.QuotationId > 0 && this.data.ProductModels.length > 0
        ? false
        : true;
    },
    ReviewStatus() {
      return this.data.Status == 2 ? true : false;
    },
    canPrice() {
      return this.$permission.canPrice("/business/sales/quotation");
    },
    canWrite() {
      return this.$permission.canWrite("/business/sales/quotation");
    },
    canReview() {
      return this.$permission.canReview("/business/sales/quotation");
    },
  },
  mounted() {
    this.init();
    // this.api.list({}).then((res) => (this.productList = res.Data));
    if (this.$route.params.isSave) this.isSave = true;
    if (this.$route.params.mode == "create" || !this.$route.params.mode) {
      this.createOrder();
    }
    if (this.$route.params.mode == "edit") {
      this.editOrder(this.$route.params.data.QuotationId);
    }
    if (this.$route.params.mode == "details") {
      this.editOrder(this.$route.params.data.QuotationId);
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: "报价单", Url: "business/sales/quotation/edit" });
      })
    },
    setTbField() {
      this.showDetail = false;
      this.docSetting_api.list({ DocType: "报价单", IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey);
          this.$nextTick(() => {
            this.showDetail = true;
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1;
    },
    goJump() {
      let params = {}
      params.SourceDocNo = this.data.DocNo;
      // params.SourceType=1
      this.$router.push({ name: 'saleorder', params: params })
    },
    onInsert(e) {
      let { type, index } = e;

      this.interpolate(null, index, type)

    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        QuotationProductId: 0,
        QuotationId: 0,
        ProductId: 0,
        ColorId: null,
        SaUnitId: 0,
        SaQuantity: 0,
        UnitId2: null,
        Quantity2: 0,
        Rate: 0,
        QuotedPrice: 0,
        Discount: 0,
        TaxRate: 0,
        Price: 0,
        SalePrice: 0,
        TaxPrice: 0,
        Amount: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        DiscountAmount: 0,
        LineAbort: false,
        LineAbortEmpId: "",
        LineAbortDate: "",
        ColorName: "",
        ProductNo: "",
        ProductName: "",
        SaUnitName: "",
        UnitName2: "",
        LineAbortEmpName: "",
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableList.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableList));
      this.tableList = [];
      this.$nextTick(() => {

        this.tableList = copy;
      })

    },

    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({ TradeUnitTypes: [0, 2], Status: 1 });
        // that.getData();
      });
    },
    previewNo(val = '') {
      this.code_api.previewNo("销售报价单", val).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取销售报价单编码失败");
        }
      });
    },
    init() {
      this.callOptionApi();
      this.tradeUnitApi.list({ TradeUnitTypes: [0, 2], Status: 1 }).then((res) => {
        if (res.Code == 0) this.tradeUnitList = res.Data;
      });
      this.transportApi.list({}).then((res) => {
        if (res.Code == 0) this.transportList = res.Data;
      });
      this.pdApi.list({ Property: "销售", pageIndex: 1, pageSize: 7, Status: 1, }).then((res) => {
        this.DAccount = res.Data;
        this.initDAccount = res.Data;
        this.listTotal = res.Count;
        this.initTotal = res.Count;
      });
      this.setTbField();
    },
    createOrder() {
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
        this.data.MakeEmpId = user.id;
        this.data.MakeEmpName = user.name;
      }
      this.addList();
      this.previewNo();
    },
    editOrder(data, type = 0) {
      this.api.info(data).then((res) => {
        if (res.Code === 0) {
          this.isSave = true;

          this.data = res.Data;
          this.Status = res.Data.Status
          this.tableList = res.Data.ProductModels.map(
            (item) => ((item.T = 3), item)
          );

          if (type === 1) {
            this.Review()
          }
        }
        if (res.Data.ProductModels.length == 0) this.addList();
      });
    },
    save(type = 0) {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        const Product = JSON.parse(JSON.stringify(this.data.ProductModels));
        console.log(Product, 'Product')
        const TableList = JSON.parse(JSON.stringify(this.tableList));
        this.tableList = this.tableList.filter((i) => i.ProductId != 0);
        for (let i = 0; i <= this.tableList.length - 1; i++) {
          if (this.tableList[i].SaQuantity == null || this.tableList[i].SaQuantity == 0) return this.$message.warning("数量不能为空并且不为0");
          if (this.tableList[i].UnitType && this.tableList[i].UnitId2 == null) return this.$message.warning("计量单位2不能为空");
          if (this.tableList[i].UseColor && (this.tableList[i].ColorId === 0 || this.tableList[i].ColorId == null)) {
            this.$message.error(`存货${this.tableList[i].ProductName}未填写颜色`)
            return;
          }

        }
        // if (this.tableList.filter((i) => i.UnitId2 === null).length !== 0)
        //   return this.$message.warning("计量单位2不能为空");

        if (this.data.ProductModels.length > 0) {
          let delIds = this.tableList.map((item) => item.ProductId);
          let delList = this.data.ProductModels.reduce((arr, item) => {
            if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
            return arr;
          }, []);

          let addIds = this.data.ProductModels.map((item) => item.ProductId);
          let addList = [];
          addList = this.tableList.reduce((arr, item) => {
            if (!addIds.includes(item.ProductId)) arr.push({ ...item, T: 0 });
            return arr;
          }, []);

          let updateList = this.tableList.filter((i) => i.T == 1);
          this.data.ProductModels = [...addList, ...delList, ...updateList];
        } else this.data.ProductModels = this.tableList;

        var data = this.$commonJs.obj.removeNullKey(this.data);
        // 等于空设置为0
        data.ProductModels.forEach(item => {
          Object.keys(item).forEach(key => {
            if (key === 'UnitId2') return;
            if (item[key] == null && key !== 'LineAbortDate' && key !== 'DeliveryDate') {
              item[key] = 0;
            }
          })
        })
        this.api.save(data).then((res) => {
          if (res.Code === 0) {
            const id = res.Data === 0 ? this.data.QuotationId : res.Data;
            this.isSave = true;
            this.is_orderUpdateStatus = false;
            this.editOrder(id, type);
            if (type !== 1) {
              this.$message.success("保存成功");
            }
          } else {
            this.tableList = TableList;
            this.ProductModels = Product;
            this.data.ProductModels = Product
            this.$message.error(res.Msg);
          }
        }).catch(err => {
          this.tableList = TableList;
          this.ProductModels = Product;
          this.data.ProductModels = Product
        })
      });
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({ Property: "销售", pageIndex: val, pageSize: 7, Status: 1, ProductName: text1, })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.pdApi
        .list({
          Property: "销售",
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          Status: 1,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    setProduct(row, index) {
      let data = this.productList.filter(
        (item) => item.ProductId === row.ProductId
      );
      this.tableList[index].ProductName = data[0].ProductName;
      this.tableList[index].ProductNo = data[0].ProductNo;
      this.tableList[index].ProductSpec = data[0].ProductSpec;
      this.tableList[index].SaUnitName = data[0].SaUnitName;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log("e", e);
      let Product = this.tableList.map((i) => i.ProductId);
      if (Product.includes(e.ProductId))
        return this.$message.warning("产品已存在");
      if (this.data.TradeUnitId == null || this.data.TradeUnitId == "") return this.$message.warning("请先选择客户");

      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1;
      row.ProductNo = e.ProductNo;
      row.ProductName = e.ProductName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.SaUnitId = e.SaUnitId;
      row.SaUnitName = e.SaUnitName;
      row.UseColor = e.UseColor;
      row.Colors = e.Colors;
      row.UnitType = 0;
      row.Units = e.Units;
      row.UnitId = e.SaUnitId;
      row.ChangeType = 0;
      // this.colorList = e.Colors;
      // this.optionList = e.Units;
      console.log("SaQuantity", Number(row.SaQuantity));
      // if (!Number(row.SaQuantity)) row.SaQuantity = 1;
      if (e.Units.length === 0) {
        row.UnitId2 = 0;
        row.SaUnitName = e.SaUnitName;
        row.UnitName2 = '';
        row.Rate = 0;
        row.Quantity2 = 0;
      } else {
        row.UnitType = 1
        if (row.SaUnitId) {
          let index = this.getUnitIndex(3, e.Units, row.SaUnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          e.Units.forEach(item => {
            if (item.ChangeType == 1) row.ChangeType = item.ChangeType
          })

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = this.getIinvexchrate(assistData.Rate);
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = this.getIinvexchrate(data.Rate);
          }
          // console.log(row.Rate,'row.Rate')
          // console.log(assistData,'assistData')
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.SaUnitId = mainData[0].UnitId;
          row.SaUnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = this.getIinvexchrate(noMainData[0].Rate);
          row.IsMain = true;
        }
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.SaQuantity / Number(row.Rate));
        } else {
          row.Quantity2 = this.getQuantity(row.SaQuantity * Number(row.Rate));
        }
        row.Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0);
        row.TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      }
      this.api.productPrice({
        TradeUnitId: this.data.TradeUnitId,
        ProductId: e.ProductId,
      })
        .then((res) => {
          if (res.Data) {
            row.SalePrice = res.Data.SalePrice;
            row.RetailPrice = res.Data.RetailPrice;
            row.PurchasePrice = res.Data.PurchasePrice;
            row.QuotedPrice = res.Data.QuotationPrice
            row.Price = res.Data.QuotationPrice
            row.TaxPrice = res.Data.QuotationPrice

          }
        });
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return;
      if (row.T === 3) row.T = 1;
      this.changeQuantity(this.tableList[index].SaQuantity, row, index)
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;
      this.isMainUnitId2 = true;
      if (data.IsMain) {
        this.tableList[index].IsMain = false
      } else {
        this.tableList[index].IsMain = true
      }
      let findIndex = 0
      if (row.SaUnitId == row.UnitId2) {
        let num = 0
        num = row.SaQuantity
        row.SaQuantity = row.Quantity2
        row.Quantity2 = num
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex)
        }
      } else {
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex, data.Rate)
        }
      }
      this.changeQuantity2(this.tableList[index].Quantity2, row, index)
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) this.tableList[index].T = 1;
      this.tableList[index].IsMain = data.IsMain
      let findIndex = 0
      if (row.SaUnitId == row.UnitId2) {
        let num = 0
        num = row.SaQuantity
        row.SaQuantity = row.Quantity2
        row.Quantity2 = num
        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex)
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
        }


      }
      this.changeQuantity(this.tableList[index].SaQuantity, row, index)
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].UnitId2 = this.tableList[index].Units[findIndex].UnitId
      this.tableList[index].UnitName2 = this.tableList[index].Units[findIndex].UnitName
      if (Rate > 0) {
        this.tableList[index].Rate = this.getIinvexchrate(Rate)
      }
    },
    changeQuantity2(data, row, index) {
      if (data < 0 || data == '') return
      console.log(data, row.Rate)

      data = Number(this.getQuantity(data));
      row.Quantity2 = data

      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1) {
          if (row.SaQuantity === '' || row.SaQuantity === 0) {
            return;
          }
          row.Rate = this.getIinvexchrate(data / row.SaQuantity)
        } else {
          console.log("数量1=数量2/换算率")
          row.SaQuantity = this.getQuantity(data / row.Rate);
        }
      } else {
        if (row.ChangeType == 1) {
          if (row.SaQuantity === '' || row.SaQuantity === 0) {
            return;
          }
          row.Rate = this.getIinvexchrate(row.SaQuantity / data);
        } else {
          console.log("数量1=数量2*换算率")
          row.SaQuantity = this.getQuantity(data * row.Rate);
        }

      }
    },
    getChangeQuantity(data, row, index) {
      if (row.SaQuantity === '' || row.SaQuantity === 0) {
        if (row.Quantity2 && row.Rate) {
          if (row.IsMain) {
            row.SaQuantity = this.getQuantity(row.Quantity2 * Number(row.Rate));
          } else {
            row.SaQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate));
          }
        }
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    //获取计量单位主辅单位的索引 
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].SaUnitId = this.tableList[index].Units[findIndex].UnitId
      this.tableList[index].SaUnitName = this.tableList[index].Units[findIndex].UnitName
      if (Rate > 0) {
        this.tableList[index].Rate = this.getIinvexchrate(Rate)
      }
    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.addList();
      }
    },
    // compareUnitId(data, row, index) {

    //   this.tableList[index].Rate = data.UnitId === row.SaUnitId ? 1 : data.Rate;
    // },
    discount(data, index) {
      if (this.tableList[index].T === 3) this.tableList[index].T = 1;
    },

    gifToggle(data, index) {
      // console.log(data);
      // console.log(index);
      if (data) this.tableList[index].price = 0;
    },
    // path:"/business/purchase/inquiry"

    RestartOrder() {
      this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
      this.createOrder();
      this.addList();
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 30);
    },

    orderUpdate() {
      this.$message.success("变更");
      this.is_orderUpdateStatus = true;
    },
    Review() {
      this.api.review(this.data.QuotationId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.editOrder(this.data.QuotationId);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.QuotationId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "back" : "review";
          if (data === 'review') {
            this.save(1);
          } else if (data === 'back') {
            this.api[data](this.data.QuotationId).then((res) => {
              if (res.Code === 0 && data == "review") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "back") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.editOrder(this.data.QuotationId);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.QuotationId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.QuotationId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    delTableList(data, index) {
      // this.$message.success("删除");
      this.tableList.splice(index, 1);
      if (this.tableList.length === 0) this.addList();
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
      this.data.DpId = data.DpId;
      this.data.DpName = data.DpName;
      this.data.DpNo = data.DpNo;
    },

    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PropertyId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    //单据保存回显
    initerPrice(price) {
      this.currentRow.Price = price;
      this.changePrice(this.currentRow, this.currentIndex)
    },
    openSales(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      let ProductName = row.ProductName;
      let TradeUnitName = this.data.TradeUnitName;
      this.$refs.orderDialog.open().then(that => {
        that.setData(ProductName, TradeUnitName);
      })
      // this.$refs.orderDialog.open();
    },
    openPrint() {
      this.columnkey = quotationList.Data.map((i) => i.tableName);
      this.columns = quotationList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label };
        acc.push({ label: item.label, data: print });
        return acc;
      }, []);
      this.formData = quotationList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.data[item.tableName],
        });
      }, []);
      this.$refs.printDialog.open();
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    addList() {
      this.tableList.push({
        T: 0,
        QuotationProductId: 0,
        QuotationId: 0,
        ProductId: 0,
        ColorId: null,
        SaUnitId: 0,
        SaQuantity: null,
        UnitId2: null,
        Quantity2: null,
        Rate: null,
        QuotedPrice: null,
        Discount: 100,
        TaxRate: null,
        Price: null,
        SalePrice: null,
        TaxPrice: null,
        Amount: null,
        TaxAmount: null,
        TaxLimit: null,
        DiscountAmount: null,
        LineAbort: false,
        LineAbortEmpId: "",
        LineAbortDate: "",
        ColorName: "",
        ProductNo: "",
        ProductName: "",
        SaUnitName: "",
        UnitName2: "",
        LineAbortEmpName: "",
        Remark: "",
      });
    },

    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
      console.log(data, 'data')
      this.data.TradeUnitType = data.TradeUnitType;
      //this.data.Address=data.DistrictName
      this.data.Address = data.DistrictName;
      if (this.data.Address == null) {
        //  adressApi.list   
        let params = {
          pageIndex: 1,
          pageSize: 10,
          TradeUnitId: this.data.TradeUnitId
        }
        params = JSON.parse(JSON.stringify(params));
        this.adressApi.list(params).then((res) => {
          if (res.Code === 0) {
            this.data.Address = res.Data[0].ArrivalAddress
          }
          if (res.Code === 1) {
            this.$message.error(res.Msg);
          }
        });
      }
      //Address

    },
    // 貌似需要审核后才可以进行 修改 行中止
    changeLineAbort(data, row) {
      if (this.data.QuotationId == 0 || row.QuotationProductId == 0)
        return (row.LineAbort = false);
      if (!Number(row.QuotationProductId)) return;
      this.api
        .lineAbort({
          Id: row.QuotationProductId,
          IsLineAbort: data,
        })
        .then((res) => {
          if (res.Code === 1) {
            row.LineAbort = !data;
            return this.$message.error(res.Msg);
          }
        });
    },
    changeColor(row, index) {
      if (row.T === 3) this.tableList[index].T = 1;
    },
    validInput(row, index, type) {
      if (row.T === 3) this.tableList[index].T = 1;
      if (!Number(row.SaQuantity)) {
        this.$message.warning("请先填写数量");
        return true;
      }
      return false;
    },

    changeIsGift(val, row) {
      row.IsGift = val;
      if (row.IsGift) {
        row.Price = 0;
        row.Price2 = 0;
        row.Amount = 0;
      }
    },

    changeQuantity(data, row, index) {

      if (data < 0) return;

      data = Number(this.getQuantity(data))

      row.SaQuantity = data;

      //转换类型
      //  row.SaQuantity=parseFloat(row.SaQuantity)
      if (row.T == 3) this.tableList[index].T = 1;
      if (row.IsMain) {
        row.Quantity2 = (row.SaQuantity / row.Rate).toFixed(2);
      } else {
        row.Quantity2 = (row.SaQuantity * row.Rate).toFixed(2);
      }
      // // this.tableList[index].Quantity2=data*row.Rate
      // if (this.optionList.length > 0 && row.UnitId2 != 0) {
      //   const mainList = this.optionList
      //     .filter((i) => i.IsMain)
      //     .map((sub) => sub.UnitId);
      //   if (mainList.includes(row.SaUnitId) && this.isMainUnitId2 == false)
      //     row.Quantity2 = (row.SaQuantity / row.Rate).toFixed(2);
      //   else if (!mainList.includes(row.SaUnitId) && this.isMainUnitId2 == true)
      //     row.Quantity2 = row.SaQuantity * row.Rate;
      //   else row.Quantity2 = Number(row.SaQuantity);
      // } else row.Quantity2 = Number(row.SaQuantity);
      // // 含税金额
      // if (Number(row.TaxPrice)) {
      //   let TaxAmount = row.TaxPrice * data * (Number(row.Discount ?? 0) / 100);
      //   this.tableList[index].TaxAmount = TaxAmount.toFixed(2);
      // }
      // // 税额
      // if (Number(row.QuotedPrice) && Number(row.TaxRate)) {
      //   let TaxLimit =
      //     Number(row.QuotedPrice) * (Number(row.TaxRate) / 100) * data;
      //   this.tableList[index].TaxLimit = TaxLimit.toFixed(2);
      // }
      // // 金额
      // if (Number(row.Price)) {
      //   let Amount = Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
      //   this.tableList[index].Amount = Amount.toFixed(2);
      // }
      // // 折扣金额
      // if (Number(row.QuotedPrice) && Number(row.Discount)) {
      //   let DiscountAmount =
      //     Number(row.QuotedPrice * (Number(row.Discount) / 100)) * data;
      //   this.tableList[index].DiscountAmount = DiscountAmount.toFixed(2);
      // }

      // 金额
      if (Number(row.Price)) {
        let Amount = Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * data * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate)) / 100;
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(data);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }
    },
    // 报价
    changeQuotedPrice(row, index) {
      // row.QuotedPrice=parseFloat(row.QuotedPrice)
      if (row.T === 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price)

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate)) / 100;
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(row.SaQuantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 折扣
    changeDiscount(row, index) {
      if (this.validInput(row, index, "Discount")) return;

      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price)


      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate)) / 100;
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(row.SaQuantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 单价
    changePrice(row, index) {

      if (this.validInput(row, index, "Price")) return;

      row.Price = this.getPrice(row.Price)

      if (row.T == 3) this.tableList[index].T = 1;
      let quantityNum = 0
      if (row.Units.length === 0) {
        quantityNum = row.SaQuantity
      } else {
        if (row.IsMain) {
          quantityNum = row.SaQuantity
        } else {
          quantityNum = row.Quantity2
        }
      }
      row.quantityNum = quantityNum;

      let rate = null;

      if (row.QuotedPrice == 0 || row.QuotedPrice == null || row.QuotedPrice == "") {

        rate = this.tableList[index].Discount / 100;
        if (rate === 1) {
          row.QuotedPrice = row.Price;
        } else {
          row.QuotedPrice = parseFloat((row.Price * row.Discount).toFixed(2))
        }
      } else {
        rate = Number(row.Price) / Number(row.QuotedPrice) * 100
        this.tableList[index].Discount = parseFloat((rate).toFixed(2));
      }

      row.changeMode = 1;

      // 修改单价
      let equation = null;
      if (row.Discount == 100) {
        equation = Number(row.QuotedPrice)
      } else {
        equation = row.Price
      }

      // 金额
      if (Number(row.quantityNum)) {
        console.log("row.quantityNum", row.quantityNum)
        let Amount = equation * Number(row.quantityNum);
        console.log("equation", equation)
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

      // 修改含税单价
      let TaxPrice = equation * (100 + Number(row.TaxRate)) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // this.changeDiscount(row, index);

      if (Number(row.QuotedPrice)) {
        // this.tableList[index].TaxPrice = Number(equation) < 0 ? 0 :  parseFloat(Number(equation).toFixed(2));
        // this.tableList[index].Price = equation < 0 ? 0 : equation.toFixed(2);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.QuotedPrice - equation) * row.quantityNum;

        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      }
      if (Number(row.TaxRate)) {

        let TaxLimit = equation * row.quantityNum * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税率
    changeTaxRate(row, index) {
      if (this.validInput(row, index, "TaxRate")) return;

      if (row.T == 3) this.tableList[index].T = 1;
      row.TaxRate = this.getIinvexchrate(row.TaxRate)
      // 修改税额
      let TaxLimit = Number(row.Price ?? 0) * Number(row.SaQuantity) * ((row.TaxRate ?? 0) / 100)
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));

      // 修改含税单价
      let TaxPrice = row.Price * (100 + Number(row.TaxRate)) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // 含税金额
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));

    },
    // 含税单价
    changeTaxPrice(row, index) {
      if (this.validInput(row, index, "TaxPrice")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = row.TaxPrice / (1 + row.TaxRate / 100)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.QuotedPrice) * 100
      this.tableList[index].Discount = Number((rate).toFixed(2));

      // 修改金额
      let Amount = Number(row.Price) * Number(row.SaQuantity) * (row.Discount / 100)
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税额
    changeTaxLimit(row, index) {
      if (this.validInput(row, index, "TaxLimit")) return;
      if (row.T == 3) this.tableList[index].T = 1;



      if (row.changeMode === 0 || row.changeMode == null) {
        // 修改金额
        let Amount = Number(row.TaxAmount) - Number(row.TaxLimit);
        this.tableList[index].Amount = Number(Amount.toFixed(2));

        // 修改单价
        let Price = Number(row.Amount) / Number(row.SaQuantity)
        this.tableList[index].Price = Number(this.getPrice(Price))

        // this.changePrice(row, index)

        // 修改折扣率
        let rate = Number(row.Price) / Number(row.QuotedPrice) * 100
        this.tableList[index].Discount = Number((rate).toFixed(2));

        // 修改含税单价
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate ?? 0)) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity;
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

        // 修改含税金额
        if (Number(row.TaxLimit) || Number(row.Amount)) {
          let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
          this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
        }



      } else {
        // 修改含税金额
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));

        // 修改含税单价
        let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity);
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }
    },
    // 金额
    changeAmount(row, index) {
      if (this.validInput(row, index, "Amount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity)
      this.tableList[index].Price = this.getPrice(Price)

      // 修改报价
      if (Number(this.tableList[index].Discount) === 100) {
        row.QuotedPrice = this.tableList[index].Price;
      }

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.QuotedPrice) * 100
      this.tableList[index].Discount = Number(((rate).toFixed(2)));

      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      // this.changePrice(row, index)
      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate)) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      }

      // 修改税额
      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 含税金额
    changeTaxAmount(row, index) {
      if (this.validInput(row, index, "TaxAmount")) return;

      if (row.T == 3) this.tableList[index].T = 1;

      row.changeMode = 0;

      // 修改金额
      let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
      this.tableList[index].Amount = Number(Amount.toFixed(2));


      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.QuotedPrice) * 100
      this.tableList[index].Discount = Number((rate).toFixed(2));

      // 修改含税单价
      let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity)
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))


      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
    },
    // 折扣金额
    changeDiscountAmount(row, index) {
      if (this.validInput(row, index, "DiscountAmount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = row.QuotedPrice - (row.DiscountAmount / row.SaQuantity)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率

      let rate = Number(row.Price) / Number(row.QuotedPrice) * 100
      this.tableList[index].Discount = Number((rate).toFixed(2));

      // 金额
      let Amount = Number(row.Price) * Number(row.SaQuantity) * (Number(row.Discount) / 100);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = Number(row.Price) * (100 + Number(row.TaxRate)) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      }

      // 修改税额
      if (Number(row.TaxRate)) {

        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    renderHeader(h, { column }) {
      return h("div", [
        h("span", column.label),
        h("i", {
          class: "el-icon-s-order",
          style: "font-size:14px;cursor: pointer;",
          on: {
            click: this.openSales,
          },
        }),
      ]);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 100px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
